function setGoogleSubscriptionOnHoldAlertShown() {
  return {
    type: 'SET_GOOGLE_SUBSCRIPTION_ON_HOLD_ALERT_SHOWN',
    alertShown: true,
  };
}

module.exports = {
  setGoogleSubscriptionOnHoldAlertShown,
};
